<template>
  <transition name="fade-long">
    <div v-if="isSurveyBannerShown" class="banner-line-survey" @click.stop="isPopupShown = true">
      <v-img src="@/assets/banner-line-survey/banners/banner-xs.jpg" contain class="banner-line-survey__img h-100 d-md-none" :aspect-ratio="319/71"></v-img>
      <v-img src="@/assets/banner-line-survey/banners/banner-lg.jpg" contain class="banner-line-survey__img h-100 d-none d-md-block" :aspect-ratio="80/7"></v-img>

      <svgicon @click.prevent.stop="onCloseClick" class="banner-line-survey__close" name="cross-bold" :original="true"/>

      <v-dialog content-class="banner-line-survey__dialog-content" v-model="isPopupShown" :width="900" :fullscreen="!isWindowMD" scrollable transition="fade-long">
        <banner-survey @close="isPopupShown = false"/>
      </v-dialog>
    </div>
  </transition>
</template>

<script>
import BannerSurvey from '@/components/survey/banner-survey.vue';
import surveyBanner, {SURVEY_CLOSED_STORAGE_KEY, SURVEY_POLL_CODE} from '@/mixins/survey-banner';

export default {
  name: 'banner-line-survey',
  components: {
    BannerSurvey
  },
  mixins: [surveyBanner],
  data: () => {
    return {
      isPopupShown: false,
    }
  },
  computed: {
    isWindowMD() {
      return this.$store.getters.isWindowMD;
    },
  },
  watch: {
    isHomePage() {
      // временное скрытие на главной действует только до ухода с неё
      this.$store.state.isSurveyBannerHidden = false;
    },
  },
  methods: {
    onCloseClick() {
      if (this.isHomePage) {
        this.$store.state.isSurveyBannerHidden = true;
        return;
      }
      this.$store.state.isSurveyBannerClosed = true;
      try {
        localStorage.setItem(SURVEY_CLOSED_STORAGE_KEY, '1');
      } catch (e) {
        // без localStorage баннер просто останется закрытым до перезагрузки
      }
    },
  },
  async mounted() {
    // опрос уже пришёл с данными страницы (главная) или загружен ранее, либо закрыт навсегда - запрос не нужен
    if (!this.poll && (this.isHomePage || !this.$store.state.isSurveyBannerClosed)) {
      await this.$store.dispatch('get', {
        action: 'PollController',
        params: {
          code: SURVEY_POLL_CODE,
        },
      }).then((res) => {
        console.log('PollController GET res', res);
        this.$store.commit('setResponse', res);
        // state.response.page перетрёт ответ следующей страницы - сохраняем опрос отдельно
        if (res?.page?.PollController) this.$set(this.$store.state.page, 'PollController', res.page.PollController);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
      });
    }
  },
}
</script>

<style lang="scss">
.banner-line-survey {
  background-color: $gray2;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 50;
  @include transition-long();

  &:hover {
    .banner-line-survey__img {
      opacity: 0.8;
    }
  }

  &__img {
    width: 100%;
    @include transition-long();
  }

  &__close {
    box-sizing: content-box;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 8px;
    min-width: 8px;
    padding: 8px;
    cursor: pointer;
    @include transition();

    @include up($md) {
      left: unset;
      top: 10px;
      right: 16px;
      width: 12px;
      min-width: 12px;
      padding: 12px;
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &__dialog-content {
    box-shadow: none !important;
  }
}
</style>